// import echarts from 'echarts/lib/echarts'
//
// import 'echarts/lib/chart/radar'
// import 'echarts/lib/chart/line'
// import 'echarts/lib/chart/bar'
// import 'echarts/lib/component/legend'

import * as echarts from 'echarts/core';
import 'echarts-liquidfill';
import { BarChart, LineChart, PieChart, RadarChart, GaugeChart } from 'echarts/charts';
import {
    GridComponent,
    LegendComponent,
    AriaComponent,
    ToolboxComponent,
    TooltipComponent,
    TitleComponent,
    GraphicComponent
} from 'echarts/components';
// 注意，新的接口中默认不再包含 Canvas 渲染器，需要显示引入，如果需要使用 SVG 渲染模式则使用 SVGRenderer
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([
    BarChart,
    LineChart,
    PieChart,
    RadarChart,
    GaugeChart,
    GridComponent,
    LegendComponent,
    AriaComponent,
    ToolboxComponent,
    TooltipComponent,
    TitleComponent,
    GraphicComponent,
    CanvasRenderer
]);

export default echarts
